"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
var StatusDot = function (_a) {
    var isHidden = _a.isHidden, className = _a.className, type = _a.type, style = _a.style;
    if (isHidden)
        return null;
    return react_1.default.createElement(styles_1.default, { style: style, className: className + " " + (type || '') });
};
exports.default = StatusDot;
//# sourceMappingURL=index.js.map